import { QueryConfig } from "store/utils/query-config";

export const chatConnectorsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
